<template>
    <div class="dragable-item-container">
        <div class="drag-action-container drag-action-container-left">
            <i class="fas fa-bars drag-holder" />
            <span class="header-name">{{ item.displayName }}</span>
        </div>
        <div class="drag-action-container">
            <div class="drag-round-btn remove-btn" @click="handleRemove()"><i class="el-icon-delete-solid" /></div>
            <el-popover
                :width="popoverWidth"
                placement="bottom"
                trigger="click"
            >
                <div slot="reference" class="drag-round-btn"><i class="el-icon-more" /></div>

                <el-form ref="form" :model="item" size="mini">
                    <el-form-item prop="label">
                        <form-input 
                            label="Label"
                            size="mini"
                            :input-value.sync="item.displayName"
                        />
                    </el-form-item>
                    
                    <el-form-item prop="width">
                        <form-radio 
                            :input-value.sync="item.widthType"
                            label="Width (px)"
                            size="mini"
                            :options="widthTypeOpts"
                            @handleChange="handleChangeWidthType"
                        />
                        
                        <form-input-number 
                            v-if="item.widthType == 'WIDTH'"
                            class="width-container"
                            size="mini"
                            :input-value.sync="item.width"
                        />
                        
                        <form-input-number 
                            v-if="item.widthType == 'MINWIDTH'"
                            class="width-container"
                            size="mini"
                            :input-value.sync="item.minWidth"
                        />
                    </el-form-item>

                    <el-form-item prop="fixed">
                        <form-select 
                            :input-value.sync="item.freezeColumn"
                            label="Always FREEZE this column"
                            :options="freezeOpts"
                        />
                    </el-form-item>
                    
                    <el-form-item prop="sortable">
                        <form-select 
                            :input-value.sync="item.isSortable"
                            label="Sort"
                            :options="sortableOpts"
                        />
                    </el-form-item>
                </el-form>
            </el-popover>
        </div>
    </div>
</template>

<script>
import FormInput from "@/components/Form/FormInput";
import FormInputNumber from "@/components/Form/FormInputNumber";
import FormRadio from "@/components/Form/FormRadio";
import FormSelect from "@/components/Form/FormSelect";

export default {
    components: {
        "form-input": FormInput,
        "form-input-number": FormInputNumber,
        "form-radio": FormRadio,
        "form-select": FormSelect,
    },
    props: {
        item: {
            type: Object,
        }
    },
    data() {
        return {
            headerForm: {
                name: null, 
                width: null,
                minWidth: null,
                label: null,
                fixed: null,
                sortable: null
            },
            widthTypeOpts: [
                { id: "AUTO", name: "Auto", value: "AUTO" },
                { id: "WIDTH", name: "Width ", value: "WIDTH" },
                { id: "MINWIDTH", name: "Min Width ", value: "MINWIDTH" },
            ],
            freezeOpts: [
                { id: "left", name: "Left", value: "left" },
                { id: "right", name: "Right", value: "right" }
            ],
            sortableOpts: [
                { id: false, name: "No", value: false },
                { id: true, name: "Yes", value: true },
            ],
        };
    },
    computed: {
        popoverWidth() {
            if (screen.width < 450 && screen.width >= 300) return 250;
            else if (screen.width < 300) return 180;
            else return 380;
        },
    },
    methods: {
        handleChangeWidthType(event) {
            if (event == "AUTO") {
                this.item.width = null;
                this.item.minWidth = null;
            }
        },
        handleRemove() {
            this.$emit("updateVisibleItem", this.item.dataName);
        }
    },
};
</script>

<style lang="css" scoped>
.dragable-item-container {
    padding: var(--space-4) var(--space-8) var(--space-4) var(--space-12);
    border: 1px solid var(--seperation-line-grey);
    border-radius: var(--space-4);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--space-4);
    height: 35px;
}
.drag-holder {
    font-size: 14px;
    color: var(--charcoal-black);
}
.drag-holder:hover {
    cursor: move;
}
.header-name {
    color: var(--charcoal-black);
    font-size: 14px;
    margin-left: var(--space-12);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.drag-round-btn{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--section-title);
    font-size: var(--default-round-btn-icon-size);
}
.drag-round-btn:hover{
    background-color: var(--table-odd-grey);
    color: var(--pure-black);
    cursor: pointer;
}
.width-container {
    margin-top: var(--space-8);
}
.drag-action-container {
    display: flex;
    align-items: center;
}
.drag-action-container-left {
    width: 80%;
}
.remove-btn {
    margin-left: var(--space-8);
    margin-right: var(--space-4);
}
</style>


// WEBPACK FOOTER //
// src/components/TableConfiguration/DragableItem.vue